import {ApplicationState} from '../ApplicationState'

export const pathSelector = (state: ApplicationState) => state.router!.location.pathname
export const queryStringSelector = (state: ApplicationState) => state.router!.location.search